import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 90000, // 90s to accommodate first-time AI qualitative generation (~30-50s)
});

export async function fetchStock(ticker) {
  const { data } = await api.get(`/stocks/${encodeURIComponent(ticker)}`);
  return data;
}

export async function searchStocks(q) {
  const { data } = await api.get(`/stocks/search`, { params: { q } });
  return data.results || [];
}

export async function listAllStocks() {
  const { data } = await api.get(`/stocks`);
  return data;
}

// Streaming AI Q&A using fetch (SSE)
export async function streamAsk(ticker, question, onDelta, onDone, onError) {
  try {
    const res = await fetch(`${API}/ai/ask`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ticker, question }),
    });
    if (!res.ok || !res.body) {
      const txt = await res.text().catch(() => "");
      onError?.(txt || `HTTP ${res.status}`);
      return;
    }
    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buf = "";
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      buf += decoder.decode(value, { stream: true });
      const parts = buf.split("\n\n");
      buf = parts.pop() || "";
      for (const chunk of parts) {
        const line = chunk.trim();
        if (!line.startsWith("data:")) continue;
        const jsonStr = line.slice(5).trim();
        if (!jsonStr) continue;
        try {
          const evt = JSON.parse(jsonStr);
          if (evt.delta) onDelta?.(evt.delta);
          if (evt.done) {
            onDone?.();
            return;
          }
          if (evt.error) {
            onError?.(evt.error);
            return;
          }
        } catch {
          /* ignore */
        }
      }
    }
    onDone?.();
  } catch (e) {
    onError?.(e?.message || String(e));
  }
}
